import { JsonResponse, SupersetClient } from '@aibi-ui/core';
import { Behaviors } from 'src/types/Behaviors';

/** 列出所有行为 */
export const getBehaviorsBehaviors = (
  searchParams?: Partial<Behaviors.ListQuery>,
): Promise<JsonResponse<{ result: Behaviors.DataItem[] }>> =>
  SupersetClient.get({
    endpoint: '/api/v1/security/behaviors/behaviors',
    searchParams,
  });

/** 给角色绑定行为 */
export const postBehaviorsRolesRoleIdBind = (
  role_id: number,
  jsonPayload: { behavior_ids: number[] },
) =>
  SupersetClient.post({
    endpoint: `/api/v1/security/behaviors/roles/${role_id}/bind`,
    jsonPayload,
  });

/** 查询当前用户关联的行为 */
export const getBehaviorsUsersBehaviors = (): Promise<
  JsonResponse<{ result: Behaviors.UserBehaviors }>
> =>
  SupersetClient.get({
    endpoint: '/api/v1/security/behaviors/users/behaviors',
  });
